export default __webpack_public_path__ + "static/oeko_gas-c589387da8777effcd2b006ae64969bd.jpg";